import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();

export const GTM_CONTAINER_ID = publicRuntimeConfig.NEXT_PUBLIC_GOOGLE_TAGMANAGER_CONTAINER_ID;
export const VWO_ACCOUNT_ID = publicRuntimeConfig.NEXT_PUBLIC_VWO_ACCOUNT_ID;

const domain = publicRuntimeConfig.NEXT_PUBLIC_SITE_DOMAIN
  ? { domain: publicRuntimeConfig.NEXT_PUBLIC_SITE_DOMAIN }
  : {};

const monthsOfExpiration = 6;
const expirationDate = (monthsOfExpiration / 12) * 365;

export const cookieName = 'remote_utm_query_string';
export const cookieOptions = { expires: expirationDate, ...domain };
